module.exports = __webpack_public_path__ + "static/media/decathlon2.01dc9d6a.png";